import React from 'react'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'

const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-items: center;
    user-select: none;
`

const Heading = styled.h2`
    font-size: 30px;
    margin: 20px auto 20px auto;
`

const Description = styled.div`
    font-size: 16px;
`

export default class Header extends React.Component {
    render() {
        return (
            <Container>
                <Heading>
                    <FormattedMessage id="merge.resolveTitle" />
                </Heading>
                <Description>
                    <FormattedMessage id="merge.resolveDescription" />
                </Description>
            </Container>
        )
    }
}
